import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * La carga de Anexos vive ahora en Administración → Anexos, con previsualización antes de
 * escribir. Se mantiene la ruta para no romper enlaces guardados.
 */
export const Route = createFileRoute('/_protected/upload')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/cargas' })
  },
})
